import DonateFormPlaidComponent from '~/javascripts/components/DonateForm/PlaidComponent';
import EmailConsentCheckbox from '~/javascripts/components/DonateForm/EmailConsentCheckbox';
import PhoneNumberField from '~/javascripts/components/DonateForm/PhoneNumberField';
import PreferredIcon from '~/images/icons/thumbs-up.svg';
import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation';
import { Component } from 'react';
import { observer } from 'mobx-react';

const AchPopoutForm = observer(
  class AchPopoutForm extends Component {
    onSubmitClick = () => {
      if (this.props.validateForm()) {
        store.donateForm.disableFormSubmit = true;
        this.props.trackPayButtonClick({
          button_type: 'ACH',
        });
      }
    };

    render() {
      return (
        <div className='ach-popout-form'>
          <div className='p-2 mb-2 bg-grey-5 text-left'>
            <div className='flex items-end mb-1'>
              <img className='mr-1 px-1 hidden md-block' src={PreferredIcon} />
              <h3 className='h80 mb-0 leading-normal'>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      'views.donate_form.ach_popout_form.link_bank_preferred_header'
                    ),
                  }}
                />
              </h3>
            </div>
            <p
              className='text-small m-0 leading-normal'
              dangerouslySetInnerHTML={{
                __html: t(
                  'views.donate_form.ach_popout_form.link_bank_preferred_text'
                ),
              }}
            />
          </div>
          {!store.donateForm.isUserLoggedIn && !store.donateForm.isCalmMode && (
            <>
              <div className='flex flex-wrap input-wrapper full-name'>
                <div className='-mt-px md-mt-0 md--ml-px w-full md-w-1/2'>
                  <input
                    className='input rounded-b-none md-rounded-r-none md-rounded-bl border-grey-40'
                    data-name
                    data-parsley-error-message={t(
                      'views.donate_form.ach_popout_form.name_error'
                    )}
                    id={`${store.donateForm.campaignSlug}_donation_form_name`}
                    name='name'
                    onChange={(e) => (store.donateForm.name = e.target.value)}
                    placeholder={t(
                      'views.donate_form.ach_popout_form.name_placeholder'
                    )}
                    required={true}
                    size='110'
                    type='text'
                    value={store.donateForm.name}
                  />
                </div>
                <div className='-mt-px md-mt-0 md--ml-px w-full md-w-1/2'>
                  <input
                    className='input rounded-t-none md-rounded-l-none md-rounded-tr border-grey-40'
                    data-parsley-error-message={t(
                      'views.donate_form.ach_popout_form.surname_error'
                    )}
                    data-surname
                    id={`${store.donateForm.campaignSlug}_donation_form_surname`}
                    name='surname'
                    onChange={(e) =>
                      (store.donateForm.surname = e.target.value)
                    }
                    placeholder={t(
                      'views.donate_form.ach_popout_form.surname_placeholder'
                    )}
                    required={true}
                    size='110'
                    type='text'
                    value={store.donateForm.surname}
                  />
                </div>
              </div>
              <div className='input-wrapper'>
                <input
                  className='lh rounded border-grey-40'
                  data-email
                  data-parsley-email-tld=''
                  data-parsley-error-message={t(
                    'views.donate_form.email_error'
                  )}
                  id={`${store.donateForm.campaignSlug}_donation_form_email`}
                  name='email'
                  onChange={(e) => (store.donateForm.email = e.target.value)}
                  placeholder={t('views.donate_form.email_placeholder')}
                  required='required'
                  type='email'
                  value={store.donateForm.email}
                />
              </div>
              <EmailConsentCheckbox />
            </>
          )}

          {store.donateForm.showPhoneNumberField && <PhoneNumberField />}

          {store.donateForm.genericFormError && (
            <ul className='parsley-errors-list'>
              <li>{store.donateForm.genericFormError}</li>
            </ul>
          )}

          <DonateFormPlaidComponent
            formAction={this.props.formAction}
            onSubmitClick={this.onSubmitClick}
          >
            <button
              className={`button w-full ${
                store.donateForm.isCalmMode ? 'calm-donate-form-button' : ''
              }`}
              id='donate-button'
              type='submit'
            >
              {store.donateForm.disableFormSubmit && (
                <i className='cw-icon-loop cw-icon-spin mr-1' />
              )}
              {t('views.donate_form.submit_button_text')}
            </button>
          </DonateFormPlaidComponent>
        </div>
      );
    }
  }
);

export default AchPopoutForm;
